module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_TemplateNew_16"],"path":[{"$":{"d":"M11.5,7A4.5,4.5,0,1,0,16,11.5,4.5,4.5,0,0,0,11.5,7ZM14,12H12v2H11V12H9V11h2V9h1v2h2ZM6.05,14H2V2H8.3L12,5v.56a6,6,0,0,1,2,.53V4L9,0H0V16H7.54A6,6,0,0,1,6.05,14Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_TemplateNew_16.svg
// module id = 8/PE
// module chunks = 1